import translator from '@Components/Utilities/Translator';
import Modal from '@Components/Shared/Modals/Modal';

const AuctionInformationModal = (props) => {

    const onClose = () => {
        props.toggleModal();
    };

    return (
        <Modal containerClassName='auction-info-modal ts-modal-container' onEscapeKeyClose={onClose}>
            <Modal.Header onClose={onClose}>
                <Modal.Title>
                    {props.EventTitle}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.StartDate &&
                    <p><b>{translator.translate('sandhills.startdate')}:</b> {props.StartDate}</p>}
                {props.EndDate &&
                    <p><b>{translator.translate('sandhills.enddate')}:</b> {props.EndDate}</p>}
                {props.StartTime && <p><b>{translator.translate('sandhills.time')}:</b> {props.StartTime}</p>}
                {props.Description &&
                    <span className='description'>{props.Description}</span>}

                <div className='close-button'>
                    <button onClick={onClose}>{translator.translate('sandhills.closepage')}</button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AuctionInformationModal;